/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingSellerAgencyBranchResponseDto } from './listingSellerAgencyBranchResponseDto';

export interface ListingSellerAgencyResponseDto {
  /** @nullable */
  name: string | null;
  /** @nullable */
  logoUrl: string | null;
  /** @nullable */
  branch: ListingSellerAgencyBranchResponseDto | null;
}
